import { Injectable, inject } from '@angular/core';
import {
  EventEntry,
  FileUpload,
  BoxesEntry,
  TrackEntry,
  RegressionEntry,
} from '@models';
import JSZip from 'jszip';
import { v4 as uuidv4 } from 'uuid';
import { SceneStore } from '@stores';

@Injectable({
  providedIn: 'root',
})
export class MlTrackingService {
  sceneStore = inject(SceneStore);

  jsonString: string;
  trackingDataUpload: FileUpload;

  private trackedData: (BoxesEntry | RegressionEntry | EventEntry)[] = [];
  private startTime: number;

  initalizeTracking(): void {
    this.startTime = Date.now();
  }

  track(entry: BoxesEntry | RegressionEntry | EventEntry): void {
    this.trackedData.push({ ...entry, time: Date.now() - this.startTime });
  }

  prepareTrackingFile(): void {
    const writeData: TrackEntry[] = this.trackedData.map((entry) => {
      if ((entry as EventEntry)?.event) {
        return entry;
      } else {
        entry = entry as BoxesEntry;
        return {
          ...entry,
          detections: [...entry.detections],
        };
      }
    });
    this.jsonString = JSON.stringify(
      {
        sceneName: this.sceneStore.data().name,
        sceneIdentifier: this.sceneStore.data().identifier,
        tracking: writeData,
      },
      null,
      2,
    );

    const zip = new JSZip();
    zip.file('tracking.json', this.jsonString);
    zip.generateAsync({ type: 'blob' }).then((blob) => {
      this.trackingDataUpload = {
        id: uuidv4(),
        mimeType: 'application/x-zip',
        blob,
      };
    });
  }

  saveToFile(): void {
    const blob = new Blob([this.jsonString], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = 'tracking.json';
    anchor.click();
    URL.revokeObjectURL(url);
  }
}
